var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { FetchHttpHandler } from '@aws-sdk/fetch-http-handler';
import { buildQueryString } from '@aws-sdk/querystring-builder';
import { HttpResponse } from '@aws-sdk/protocol-http';
import { Subject } from 'rxjs';
/**
 * 自定义aws sdk s3client的HttpHandler。代码hack自aws-sdk的FetchHttpHandler
 *
 * @author biming
 */

var S3ClientHttpRequestHandler =
/** @class */
function (_super) {
  __extends(S3ClientHttpRequestHandler, _super);

  function S3ClientHttpRequestHandler(xmlHttpRequest, _a) {
    var _b = _a === void 0 ? {} : _a,
        requestTimeout = _b.requestTimeout;

    var _this = _super.call(this, {
      requestTimeout: requestTimeout
    }) || this;

    _this.onProgress$ = new Subject();
    _this.xmlHttpRequest = xmlHttpRequest;
    _this.myRequestTimeout = requestTimeout;
    return _this;
  }

  S3ClientHttpRequestHandler.prototype.handle = function (request, _a) {
    var _b = _a === void 0 ? {} : _a,
        abortSignal = _b.abortSignal; // we let XHR only handle PUT requests with body (as we want to have progress events here), the rest by fetch


    if (request.method === 'PUT' && request.body) {
      return this.handleByXhr(request, {
        abortSignal: abortSignal
      });
    }

    return _super.prototype.handle.call(this, request, {
      abortSignal: abortSignal
    });
  };
  /**
   * handles a request by XHR instead of fetch
   * this is a copy the `handle` method of the `FetchHttpHandler` class of @aws-sdk/fetch-http-handler
   * replacing the `Fetch`part with XHR
   */


  S3ClientHttpRequestHandler.prototype.handleByXhr = function (request, _a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        abortSignal = _b.abortSignal;

    var requestTimeoutInMs = this.myRequestTimeout; // if the request was already aborted, prevent doing extra work

    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
      var abortError = new Error('Request aborted');
      abortError.name = 'AbortError';
      return Promise.reject(abortError);
    }

    var path = request.path;

    if (request.query) {
      var queryString = buildQueryString(request.query);

      if (queryString) {
        path += "?" + queryString;
      }
    }

    var port = request.port,
        method = request.method;
    var url = request.protocol + "//" + request.hostname + (port ? ":" + port : '') + path;
    var body = method === 'GET' || method === 'HEAD' ? undefined : request.body;
    var requestOptions = {
      body: body,
      headers: new Headers(request.headers),
      method: method
    };
    var xhr = this.xmlHttpRequest;
    var xhrPromise = new Promise(function (resolve, reject) {
      try {
        xhr.responseType = 'blob'; // arraybuffer/blob/document/json/text
        // bind the events

        xhr.onload = function (progressEvent) {
          var ETag = xhr.getResponseHeader('ETag');
          resolve({
            body: xhr.response,
            headers: {
              'etag': ETag,
              'x-amz-request-id': xhr.getResponseHeader('x-amz-request-id')
            },
            status: xhr.status
          });
        };

        xhr.onerror = function (progressEvent) {
          return reject(new Error(xhr.responseText));
        };

        xhr.onabort = function (progressEvent) {
          var abortError = new Error('Request aborted');
          abortError.name = 'AbortError';
          reject(abortError);
        }; // progress event musst be bound to the `upload` property


        if (xhr.upload) {
          xhr.upload.onprogress = function (progressEvent) {
            return _this.onProgress$.next({
              path: path,
              progressEvent: progressEvent
            });
          };
        } // @ts-ignore


        xhr.open(requestOptions.method, url); // append headers

        if (requestOptions.headers) {
          requestOptions.headers.forEach(function (headerVal, headerKey, headers) {
            if (['host', 'content-length'].indexOf(headerKey.toLowerCase()) >= 0) {
              // avoid "refused to set unsafe header" error message
              return;
            }

            xhr.setRequestHeader(headerKey, headerVal);
          });
          xhr.setRequestHeader('Access-Control-Allow-Origin', 'true');
        }

        xhr.send(requestOptions.body);
      } catch (e) {
        console.error('S3 XHRHandler error', e);
        reject(e);
      }
    });
    var raceOfPromises = [xhrPromise.then(function (response) {
      var fetchHeaders = response.headers;
      var transformedHeaders = fetchHeaders;
      var hasReadableStream = response.body !== undefined; // Return the response with buffered body

      if (!hasReadableStream) {
        return response.body.text().then(function (body) {
          return {
            response: new HttpResponse({
              headers: transformedHeaders,
              statusCode: response.status,
              body: body
            })
          };
        });
      } // Return the response with streaming body


      return {
        response: new HttpResponse({
          headers: transformedHeaders,
          statusCode: response.status,
          body: response.body
        })
      };
    }), this.requestTimeoutFn(requestTimeoutInMs)];

    if (abortSignal) {
      raceOfPromises.push(new Promise(function (resolve, reject) {
        abortSignal.onabort = function () {
          xhr.abort();
        };
      }));
    }

    return Promise.race(raceOfPromises);
  };

  S3ClientHttpRequestHandler.prototype.requestTimeoutFn = function (timeoutInMs) {
    if (timeoutInMs === void 0) {
      timeoutInMs = 0;
    }

    return new Promise(function (resolve, reject) {
      if (timeoutInMs) {
        setTimeout(function () {
          var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
          timeoutError.name = 'TimeoutError';
          reject(timeoutError);
        }, timeoutInMs);
      }
    });
  };

  return S3ClientHttpRequestHandler;
}(FetchHttpHandler);

export { S3ClientHttpRequestHandler };